import React from "react";
import HeaderTailwind from "./HeaderTailwind";
import FooterTailwind from "./FooterTailwind";

function TailwindPageWrapper({ children }) {
  return (
    <div className="min-h-screen bg-slate-50/50 dark:bg-slate-900 transition-colors">
      <HeaderTailwind />
      <div className="pt-24 min-h-screen transition-colors">
        {children}
      </div>
      <FooterTailwind />
    </div>
  );
}

export default TailwindPageWrapper;
